// "Obfuscated" routes
export const ADD_INSURANCE_ORIGIN_APP_BOOKING = 'ab';
export const ADD_INSURANCE_ORIGIN_USER_PROFILE = 'up';
export const ADD_INSURANCE_ORIGIN_BOOKING_WIDGET = 'bw';

// "Obfuscated" query params
const USER_PROFILE_ID_PARAM = 'p';

// Next routes
const FINALIZE_PAGE = '/finalize';
const USER_PROFILE_PAGE_BASE_PATH = '/account/people';
const HOME_PAGE = '/';
const SUBMIT_BOOKING = '/submitBooking';

const getUserProfilePageUrl = queryParams => {
  const userProfileId = queryParams[USER_PROFILE_ID_PARAM];
  return `${USER_PROFILE_PAGE_BASE_PATH}/${userProfileId}`;
};

export const getNextRoute = (origin, queryParams) => {
  switch (origin) {
    case ADD_INSURANCE_ORIGIN_APP_BOOKING:
      return FINALIZE_PAGE;
    case ADD_INSURANCE_ORIGIN_USER_PROFILE:
      return getUserProfilePageUrl(queryParams);
    case ADD_INSURANCE_ORIGIN_BOOKING_WIDGET:
      return SUBMIT_BOOKING;
    default:
      return HOME_PAGE;
  }
};
